import React from "react";
import {Filter, TextInput} from "react-admin";

export default props => (
    <Filter {...props}>
        <TextInput source="name@ilike" label="Name"/>
    </Filter>
);
